import { render, staticRenderFns } from "./ShoppingCartFooter.vue?vue&type=template&id=741c238c"
import script from "./ShoppingCartFooter.vue?vue&type=script&lang=ts"
export * from "./ShoppingCartFooter.vue?vue&type=script&lang=ts"
import style0 from "./ShoppingCartFooter.vue?vue&type=style&index=0&id=741c238c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports